import type { AbstractIntlMessages } from 'use-intl';

import { loadMessages } from '@/lib/i18n/messages';
import { resolvePublicLocale } from '@/lib/public-chat/load-public-chat';
import type { SupportedLocale } from '@/i18n/config';
import {
  fetchExternalShareInfo,
  type IExternalShareInfo,
} from '@/lib/api/external-chat-share.client';

export interface ExternalShareLoaderData {
  info: IExternalShareInfo;
  locale: SupportedLocale;
  messages: AbstractIntlMessages;
}

/**
 * Loader for the external-share public route. Resolves link validity + i18n.
 * A missing/expired link still resolves (with `valid: false`) so the viewer
 * can render a branded "link expired" page instead of a generic 404.
 */
export async function loadExternalShare(
  token: string,
  searchStr: string
): Promise<ExternalShareLoaderData> {
  const info = (await fetchExternalShareInfo(token)) ?? { valid: false, requiresPin: true };
  const params = new URLSearchParams(searchStr);
  const locale = resolvePublicLocale(params.get('locale') ?? undefined);
  const messages = await loadMessages(locale);
  return { info, locale, messages };
}
